import React from 'react';
import { MANAGE_DATA_HEADER_HORIZONTAL_PADDING_PX } from 'venn-components';
import { Icon, getHelpCenterLinks } from 'venn-ui-kit';

type ManageDataHeaderHistoricalErrorBannerProps = {
  children: React.ReactNode;
};
export const ManageDataHeaderHistoricalErrorBanner = ({ children }: ManageDataHeaderHistoricalErrorBannerProps) => (
  <div
    className="flex gap-[3px] py-[9px] bg-venn-error text-white"
    style={{
      paddingLeft: `${MANAGE_DATA_HEADER_HORIZONTAL_PADDING_PX}px`,
      paddingRight: `${MANAGE_DATA_HEADER_HORIZONTAL_PADDING_PX}px`,
    }}
  >
    <Icon type="triangle-exclamation" className="text-white" iconLabel="Banner historical error icon" />
    {children}
    {/* todo: follow up on VENN-28619 to update href link */}
    <a
      className="text-white font-bold"
      href={getHelpCenterLinks().HISTORICAL_PORTFOLIOS_HELP_HREF}
      target="_blank"
      rel="noopener noreferrer"
    >
      Learn more
    </a>
  </div>
);
